
//TODO System enum??
export function backSizeConverter(height : string, weight : string, system : number) {
  let h = parseFloat(height.replace(",", "."));
  let w = parseFloat(weight.replace(",", "."));

  if (system === 0) {
    //Mikkels formula to determine the correct size.
    let result = (100 * w) / (h - 30);
    if (result < 36) return "Size 0";
    if (36 < result && result < 47) return "Size 1";
    if (47 < result && result < 53) return "Size 2";
    if (53 < result && result < 58.7) return "Size 3";
    if (58.7 < result && result < 65) return "Size 4";
    if (65 < result && result < 71) return "Size 5";
    else return "Size 6";
  }
  else {
    return "N/A"
  }
}

export function elbowSizeConverter(measure : string, system : number) {
  let m = parseFloat(measure.replace(",", "."));
  if (system === 0) {
    if (m < 23) return "N/A";
    if (m <= 25) {
      return "Size 2";
    }
    if (m <= 28) {
      return "Size 3"
    }
    if (m <= 30) {
      return "Size 4";
    }
    if (m <= 34) {
      return "Size 5";
    }
    if (m > 34) return "N/A";
  }
  if (system === 1) {
    if (m < 9.1) return "N/A";
    if (m <= 9.8) {
      return "Size 2";
    }
    if (m <= 11.0) {
       return "Size 3"
    }
    if (m <= 11.8) {
      return "Size 4";
    }
    if (m <= 13.4) {
      return "Size 5";
    }
    if (m > 13.4) return "N/A";
  }
}
